import { useIntl } from "react-intl";
import Select from "react-select";
import "../LossLimits.scss";

const LossLimitsActionsSelect = ({ selectedOption, setSelectedOption }) => {
  const intl = useIntl();
  const options = [
    {
      value: "remove",
      label: intl.formatMessage({
        id: "loss-limits-remove",
        defaultMessage: "Remove Limit",
      }),
    },
    {
      value: "increase",
      label: intl.formatMessage({
        id: "loss-limits-increase",
        defaultMessage: "Increase Limit",
      }),
    },
    {
      value: "decrease",
      label: intl.formatMessage({
        id: "loss-limits-reduce",
        defaultMessage: "Reduce Limit",
      }),
    },
  ];

  return (
    <div className="loss-limit-dropdown">
      <Select
        value={selectedOption}
        onChange={option => {
          setSelectedOption(option);
        }}
        options={options}
        className="loss-limit-select"
        classNamePrefix="loss-limit-select-prefix"
        isSearchable={false}
        placeholder={intl.formatMessage({
          id: "loss-limits-select-action",
          defaultMessage: "Select Action",
        })}
        // menuIsOpen={true}
      />
    </div>
  );
};

export default LossLimitsActionsSelect;
